// import { CommonModule } from '@angular/common';
// import { NgModule, type Type, inject } from '@angular/core';
// import { MatIconModule } from '@angular/material/icon';
// import { MatTooltipModule } from '@angular/material/tooltip';
// import { RouterModule } from '@angular/router';
import type {
  NotificationService,
} from '@backoffice-frontend/notifications/util-api';
import type { Notification } from '@clean-code/models';
// import { NotificationCenterComponent } from '@clean-code/notifications/feature-notification-center';
// import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
// import { TranslocoModule } from '@jsverse/transloco';
// import { UserLimitViolationNotificationItemComponent } from './components/user-limit-violation-notification-item/user-limit-violation-notification-item.component';
// @NgModule({
//   imports: [
//     CommonModule,

import type { Type } from '@angular/core';
import { UserLimitViolationNotificationItemComponent } from './components/user-limit-violation-notification-item/user-limit-violation-notification-item.component';

//     RouterModule,

//     MatIconModule,
//     MatTooltipModule,
//     TranslocoModule,
//     FontAwesomeModule,
//     NotificationCenterComponent,
//   ],
//   declarations: [UserLimitViolationNotificationItemComponent],
// })
// export class UserLimitUiViolationNotificationModule {
//   constructor() {
//     const notificationService = inject(NotificationService);
//     notificationService.registerNotificationType({
//       componentType:
//         UserLimitViolationNotificationItemComponent as unknown as Type<Notification>,
//       name: 'UserLimitViolation',
//     });
//   }
// }

export function RegisterUserLimitViolationNotificationType(
  notificationService: NotificationService,
) {
  notificationService.registerNotificationType({
    componentType:
      UserLimitViolationNotificationItemComponent as unknown as Type<Notification>,
    name: 'UserLimitViolation',
  });
}
